// import React from 'react';
// import { FormLabel } from 'react-bootstrap';
// import Form from 'react-bootstrap/Form';

// function SelectComponent({ options, label, name, value, onChange ,defaultValue,width,disabled,required}) {
//   const handleSelectChange = (e) => {
//     const selectedValue = e.target.value;
//     onChange(selectedValue);
//   };

//   return (
//     <div className="container">
//       <FormLabel>
//         {label}{required? <span style={{color:"red"}}>*</span>:null}
//       </FormLabel>
//       <Form.Select
//         aria-label={label}
//         name={name}
//         value={value}
//         yarn upgrade
//         onChange={handleSelectChange} // Bind the event handler
//         style={{width:width}}
        
//         disabled={disabled ? disabled : false}
//       >
//         {options.map((option) => (
//           <option key={option.value} value={option.value}>
//             {option.label}
//           </option>
//         ))}
//       </Form.Select>
     
//     </div>
//   );
// }

// export default SelectComponent;


import React from "react";
import { FormLabel } from "react-bootstrap";
import Form from "react-bootstrap/Form";



const SelectComponent = ({
  options,
  label,
  name,
  value,
  onChange,
  width,
  disabled = false,
  required = false,
}) => {
  return (
    <div    style={{ padding: "8px 12px" }}
    >
      {/* Label with Required Indicator */}
      <FormLabel className="custom-label">
        {label} {required && <span className="required-asterisk">*</span>}
      </FormLabel>

      {/* Styled Select Dropdown */}
      <Form.Select
        aria-label={label}
        name={name}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{ width:width }}
        className="custom-select"
        disabled={disabled}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Form.Select>

      {/* Additional Styling */}
      <style>
        {`
          .custom-select-container {
            display: flex;
            flex-direction: column;
            gap: 6px;
            max-width: 600px;
            
          }

          .custom-label {
            font-size: 14px;
            font-weight: 600;
            color: #333;
          }

          .required-asterisk {
            color: red;
            margin-left: 3px;
          }

          .custom-select {
            padding: 10px;
            font-size: 14px;
            border: 1px solid #ccc;
            border-radius: 6px;
            transition: all 0.3s ease-in-out;
            box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
          }

          .custom-select:focus {
            border-color: #007bff;
            box-shadow: 0px 4px 10px rgba(0, 123, 255, 0.2);
          }

          .custom-select:hover {
            border-color: #0056b3;
          }

          .custom-select:disabled {
            background-color: #f5f5f5;
            cursor: not-allowed;
          }
        `}
      </style>
    </div>
  );
};

export default SelectComponent;
